import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const el = ref.current;
      if (el && el.getBoundingClientRect().top < window.innerHeight * 1.2) setFallback(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className={`block ${innerClassName}`}
        initial={{ y: "110%" }}
        animate={inView || fallback ? { y: 0 } : {}}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};
